import appConfig from 'src/utils/appConfig';

export default (flow) => {
  const isLoggedIn = appConfig.getMyConfig().uuid;
  const shouldRedirect = flow.options ? (flow.options.redirectLoggedIn) : false;

  return !!(isLoggedIn && shouldRedirect);
};
